import React, { useEffect } from "react";
import WOW from "wowjs";
import { useMediaQuery } from "Components/Custom_hooks/Custom";
function Programs() {
  const isMobile = useMediaQuery("(max-width:700px)");
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  const programs = [
    {
      title: "SAT Program",
      button: "Enroll Now",
      icon: "✔",
      delay: ".2s",
      features: [
        "Up to 40 hours of live one-on-one classes covering core preparation, doubts, and detailed reviews",
        "Complete support for both Math and Reading & Writing (RW) sections",
        "Dedicated guidance and academic support from two experienced mentors",
        "Comprehensive study material including concept notes, in-class work, and home assignments",
        "30 fully digital, adaptive SAT mock tests aligned with the latest exam pattern",
        "At least 3–4 structured online Parent-Mentor review meetings",
        "Support provided for up to two SAT attempts",
      ],
    },

    {
      title: "ACT Program",
      button: "Get Started",
      icon: "⚡",
      badge: "POPULAR",
      delay: ".4s",
      features: [
        "Private one-on-one tutoring with 25–35 hours of focused instruction",
        "Additional 5 hours dedicated exclusively to doubts and review sessions",
        "Complete support for Math, English, and Reading sections",
        "Comprehensive study material including concept notes, class assignments, and homework",
        "30 ACT digital mock tests designed as per the new exam pattern",
        "Minimum of 3–4 online Parent-Mentor progress meetings",
      ],
    },

    {
      title: "AP Program",
      button: "Talk to Advisor",
      icon: "🚀",
      delay: ".6s",
      features: [
        "Completely one-on-one personalized instruction",
        "Expert guidance from subject-matter specialists",
        "Comprehensive curriculum aligned with AP board standards",
        "Strategic exam-focused techniques and time-management methods",
        "Extensive practice tests and curated question paper bank",
      ],
    },
  ];

  return (
    <section id="programs" className="pricing-section pt-100 pb-100">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-70">
          <h1
            className="wow fadeInUp"
            data-wow-delay=".2s"
            style={{ color: "black" }}
          >
            Our Programs
          </h1>

          <p className="wow fadeInUp" data-wow-delay=".3s">
            One-on-one mentorship, structured curriculum, and proven strategies
            — everything your child needs to succeed in global standardized
            exams.
          </p>
        </div>

        {/* Cards */}
        <div
          className="pricing-cards"
          style={isMobile ? { marginLeft: "-9.5%" } : {}}
        >
          {programs.map((program, index) => (
            <div
              key={index}
              className="pricing-card wow fadeInUp"
              data-wow-delay={program.delay}
            >
              {program.badge && <div className="badge">{program.badge}</div>}

              <h2>{program.title}</h2>

              <div className="features">
                {program.features.map((feature, i) => (
                  <div className="feature" key={i}>
                    <span>{program.icon}</span>

                    <p>{feature}</p>
                  </div>
                ))}
              </div>
              <a href="#contact">
                <button>{program.button}</button>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Programs;
